module.exports = __webpack_public_path__ + "img/block5.ca2a30a0.png";